import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "Problems don't keep office hours. Our after-hours NOC support extends your coverage into nights, weekends and holidays, so your infrastructure is monitored and managed around the clock.",
    "We act as the safety net for your in-house team — watching, triaging and responding when they're off, and handing back a clean picture in the morning.",
];

const FEATURES = [
    { title: "Round-the-clock coverage", text: "Fill the gaps outside business hours without burning out your team." },
    { title: "Alert triage", text: "Issues assessed and handled or escalated per your runbook." },
    { title: "Seamless handover", text: "Clear morning reports so your team picks up exactly where we left off." },
    { title: "Cost-effective", text: "Overnight cover without the cost of staffing a full night shift." },
];

const CHECKS = [
    "Overnight & weekend monitoring",
    "Holiday coverage",
    "Alert triage & escalation",
    "Incident handling",
    "Shift handover reporting",
];

export default function AfterHoursNocSupport() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Server & Networking" title="After-Hours NOC Support" eyebrowAs="span">
                    Coverage when your team clocks off — overnight and weekend monitoring so nothing goes unwatched.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
